class MoneyInputController {

    constructor($element, moneyService) {
        this.$element = $element;
        this.moneyService = moneyService;
    }

    $onInit () {
        this.currency = this.moneyService.getCurrencyDetails(this.currencyCode || null);

        this.ngModel.$render = () => {
            if (!isNaN(this.ngModel.$viewValue) && this.ngModel.$viewValue !== null) {
                this.value = (this.ngModel.$viewValue / this.currency.magnitude).toFixed(this.currency.decimals);
            } else {
                this.value = undefined;
            }
        };
    }

    onChange () {
        if (this.value) {
            return this.ngModel.$setViewValue(Math.round(this.value * this.currency.magnitude).toFixed(this.currency.decimals));
        }
        return this.ngModel.$setViewValue(undefined);
    }

    onFocus () {
        this.$element.addClass('focus');
    }

    onBlur () {
        this.$element.removeClass('focus');

        this.ngModel.$setTouched();

        if (this.$element.find('input')[0].value) {
            this.ngModel.$setDirty();
        } else {
            this.ngModel.$setPristine();
        }
    }

    shouldDecorate (type) {
        if (!this.decorate && type === 'currency' || this.decorate === type) {
            return true;
        }
        return false;
    }
}

MoneyInputController.$inject = ['$element', 'moneyService'];

export default MoneyInputController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/base/controllers/money.input.controller.js